import ButtonSpinner from "./ButtonSpinner";

function Button(props) {
    const { disabled, colour, text, icon, iconPositionLeft, extraStyling = "", onClick, loading } = props;

    return (
        <button
            type="button"
            className={
                (disabled ? "cursor-default " : "") +
                extraStyling +
                " button disabled:opacity-50 flex items-center " +
                colour
            }
            onClick={disabled || loading ? null : () => onClick()}
            disabled={disabled}
        >
            {loading ? (
                <>
                    {<ButtonSpinner />}
                    {text}
                </>
            ) : iconPositionLeft ? (
                <>
                    {icon}
                    {text}
                </>
            ) : (
                <>
                    {text}
                    {icon}
                </>
            )}
        </button>
    );
}

export default Button;
